const rankingItems = [
  { rank: 1, title: '奔跑吧 · 第十季', heat: '热度 9.8', tag: '↑ 2位', tagUp: true, icon: 'ri-run-line' },
  { rank: 2, title: '歌手2025', heat: '热度 9.7', tag: '↑ 1位', tagUp: true, icon: 'ri-music-line' },
  { rank: 3, title: '密室大逃脱 · 第六季', heat: '热度 9.5', tag: '新上榜', tagUp: true, icon: 'ri-lock-line' },
  { rank: 4, title: '脱口秀大会 · 第五季', heat: '热度 9.3', tag: '↓ 1位', tagUp: false, icon: 'ri-emotion-laugh-line' },
  { rank: 5, title: '乘风破浪 · 第四季', heat: '热度 9.1', tag: '↓ 2位', tagUp: false, icon: 'ri-star-line' },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-8">
        <div className="text-center mb-10">
          <div className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full bg-primary-500/10 border border-primary-500/20 mb-4">
            <i className="ri-trophy-line text-primary-400 text-xs"></i>
            <span className="text-xs text-primary-400 font-medium whitespace-nowrap">实时热榜</span>
          </div>
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-100 mb-3">
            综艺热度排行榜
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            根据播放量、讨论度和搜索热度综合排序
          </p>
        </div>

        <div className="max-w-2xl mx-auto bg-background-50 rounded-xl border border-background-300/20 overflow-hidden">
          {rankingItems.map((item, idx) => (
            <a
              key={item.rank}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className={`flex items-center gap-4 px-5 py-4 transition-colors hover:bg-background-100/70 cursor-pointer ${
                idx < rankingItems.length - 1 ? 'border-b border-background-300/20' : ''
              }`}
            >
              <div className={`flex-shrink-0 w-8 h-8 rounded-lg flex items-center justify-center font-bold text-sm ${
                item.rank === 1 ? 'bg-primary-500 text-background-50' :
                item.rank === 2 ? 'bg-accent-500 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500/80 text-background-50' :
                'bg-background-200/70 text-foreground-500'
              }`}>
                {item.rank}
              </div>
              <div className="w-8 h-8 rounded-lg bg-background-200/60 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-foreground-400 text-sm`}></i>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-medium text-foreground-200 truncate">{item.title}</h3>
                <div className="text-xs text-foreground-600 mt-0.5">{item.heat}</div>
              </div>
              <span className={`text-xs font-medium whitespace-nowrap ${item.tagUp ? 'text-primary-400' : 'text-foreground-600'}`}>
                {item.tag}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}